import $ from 'jquery'

export var pollingArray = 

/* ***************  Polling array objects have this format ****************** */
[ 
    { 243127932 : //main key is a TIN
        {
            feedback: "<div>&nbsp;</div>", //html string
            intervalId: 3,
            polling: false,
            testName: "Barista2",
            gifId:  "#waitingGif-Barista2",
            feedBackDivId: "#feedback-Barista2"
        }
    }
];
/* ***************************************************************************** */

export function removeObjectByTestName(testName) {
  const index = pollingArray.findIndex(obj => {
    const innerObject = Object.values(obj)[0];
    return innerObject.testName === testName;
  });

  if (index !== -1) {
    pollingArray.splice(index, 1);
    return true; // Successfully removed the object
  }
  return false; // Object with the given testName was not found
}

export function emptyPollingArray() {
    pollingArray = [];
}

export function getPollingData() {
  return pollingArray;
}

export function isValidJSON(str) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}

export function objectToHTML(obj) {
    let htmlString = '';

    for (const [key, value] of Object.entries(obj)) {
        htmlString += `<div>${key}: ${value}</div>`;
    }

    // Remove the last <br> tag, if there are any entries
    //if (Object.keys(obj).length > 0) {
    //    htmlString = htmlString.slice(0, -4); // Remove the last 4 characters (</br>)
   // }

    return htmlString;
}

export function getPollingByTestName(testName) {
  for (const item of pollingArray) {
      // Extract the inner object from the main object
      const innerObject = Object.values(item)[0];
      console.log("location innerObject.polling: ", innerObject.polling)
      // Check if the testName matches
      if (innerObject.testName === testName) {
          return innerObject.polling;
      }
  }
  return null; // Return null if no match is found
}

export function getTINbyTestName(testName) {
  for (const item of pollingArray) {
    // Extract the inner object from the main object
    const innerObject = Object.values(item)[0];
    // Check if the testName matches
    if (innerObject.testName === testName) {
        return innerObject.TIN;
    }
}
return null; // Return null if no match is found
}

export function getFeedbackByTIN(obj, TIN) {
    // Check if the TIN exists in the object
    if (obj && obj[TIN]) {
        // Access the feedback property of the nested object
        return obj[TIN].feedback;
    } else {
        // Handle the case where the TIN does not exist in the object
        return null; // or any other suitable value indicating absence
    }
}

export function getGifIdByTIN(obj,TIN){
  if (obj && obj[TIN]) {
    // Access the feedback property of the nested object
    return obj[TIN].gifId;
} else {
    // Handle the case where the TIN does not exist in the object
    return null; // or any other suitable value indicating absence
}
}

export function getFeedBackDivIdByTIN(obj,TIN){
  if (obj && obj[TIN]) {
    // Access the feedback property of the nested object
    return obj[TIN].feedBackDivId;
} else {
    // Handle the case where the TIN does not exist in the object
    return null; // or any other suitable value indicating absence
}
}

export function findObjectByTestName(testName) {
    // Use Array.prototype.find() to search for the object
    return pollingArray.find(obj => obj && Object.values(obj)[0].testName === testName);
}

export function convertToNumberedList (paragraph) {
    // Regular expression to match numbered sentences
    const regex = /(\d+\.)\s+([^.]*)/g
  
    //  Replace each match with <li> tags and wrap in <ol> tags
    const html = paragraph.replace(regex, '<li>$2</li>')
    const numberedlist = `<ol style='margin-left: 20px;'>${html}</ol>`
  
    return numberedlist
  }

export function replaceAlternateDoubleStars (str) {
    let count = 0
    // Regular expression to match "**"
    const regex = /\*\*/g
  
    // Replace alternate "**" with <strong> and </strong>
    const replaced = str.replace(regex, function (match) {
      count++
      return count % 2 === 1 ? '<strong>' : '</strong>'
    })
  
    return replaced
  }
  
export function insertBrTagsAroundLiTags (inputString) {
    // Regular expression to match <ol> and </ol> tags
    const regex = /<ol>([\s\S]*?)<\/ol>/gi
  
    const replaced = inputString.replace(regex, function (match, p1) {
      const modifiedList = p1.replace(/(<li>)/gi, '<br>$1')
      return `<ol>${modifiedList.replace(/(<\/li>)/gi, '$1<br>')}</ol>`
    })
  
    return replaced
  }
 
  export function containsKey (key) {
    return pollingArray.some(obj => obj.hasOwnProperty(key)) //returns true if key exists, else false
  }
  
  export function removeObjectByKey (key) {
    return pollingArray.filter(obj => !obj.hasOwnProperty(key))
  }

  export function addObjectToArray (key, polling, intervalId, feedback, testName, gifId, feedBackDivId) {
    let newObject = {}
    newObject[key] = {
      polling: polling,
      intervalId: intervalId,
      feedback: feedback,
      testName: testName,
      gifId: gifId,
      feedBackDivId: feedBackDivId
    }
    pollingArray.push(newObject)
  }
  
  export function setPollingValue (key, value) {
    let obj = pollingArray.find(item => item.hasOwnProperty(key))
    if (obj) {
      obj[key].polling = value
    }
  }

  export function getPollingValue (key) {
    let obj = pollingArray.find(item => item.hasOwnProperty(key))
    if (obj) {
      return obj[key].polling
    }
  }

  export function setFeedbackAndTestName (key, value, testName)
  {
    let obj = pollingArray.find(item => item.hasOwnProperty(key))
    if (obj) {
      obj[key].feedback = value;
      obj[key].testName = testName;
    }
  }
  
  export function setToNewIntervalId (key, intervalId) {
    let obj = pollingArray.find(item => item.hasOwnProperty(key))
    if (obj) {
      obj[key].intervalId = intervalId
    }
  }
  
  export function isEmpty (obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object
  }
  
  export function getObjectPropertiesByKey (key) {
    var obj = pollingArray.find(item => item.hasOwnProperty(key))
    if (obj) {
      return obj[key]
    }
    return null // or handle the case where the key is not found
  }
  
  export function isPollingActive (key) {
    var obj = pollingArray.find(item => item.hasOwnProperty(key))
    if (obj) {
      return obj[key].polling
    }
    return null
  }
  
  export function getIntervalId (key) {
    let obj = pollingArray.find(item => item.hasOwnProperty(key))
    if (obj) {
      return obj[key].intervalId
    }
    return null // or throw an error or handle the case where the key is not found
  }  

  export function getTestNameFromIframe(){
    let iframe = $('iframe').first();
    if (iframe.length) {
      let src = iframe.attr('src');
      let url = new URL(src);
      let params = new URLSearchParams(url.search);
      let testName = params.get('testName');
      if (testName) {
        testName = testName.replace(/\s+/g, '');
      }
      console.log('testName:', testName);
      return testName;
    } else {
      return null;
    }
  }
  
  export function setWaitingId(testName) {
    let element = $('[id^="waitingGif-"]');
    if (element.length) {
      element.attr('id', 'waitingGif-' + testName);
      console.log('ID changed to:', element.attr('id'));
    } else {
      console.log('No element found with id starting with "waitingGif-"');
    }
  }
  
  export function setFeedbackId(testName) {
    let element = $('[id^="feedback-"]');
    if (element.length) {
      element.attr('id', 'feedback-' + testName);
      console.log('ID changed to:', element.attr('id'));
    } else {
      console.log('No element found with id starting with "feedback-"');
    }
  }

  export function isCellPhone() {
    function isCellPhone() {
      return /Mobi|Android/i.test(navigator.userAgent);
    }
    return isCellPhone()
  }

  export function isCellPhoneInPortrait() {
    // Function to detect if the device is a cell phone
    function isCellPhone() {
        return /Mobi|Android/i.test(navigator.userAgent);
    }

    // Function to detect if the device is in portrait orientation
    function isPortrait() {
        return window.innerHeight > window.innerWidth;
    }

    // Check if the device is a cell phone and in portrait orientation
    return isCellPhone() && isPortrait();
}

